export enum PageHeaderAlertTypes {
  TRIAL_EXPIRED = 'trial-expired',
  PAYMENT_PENDING = 'payment-pending',
  DOMAIN_RENEWAL = 'domain-renewal',
  SUBSCRIPTION_RENEWAL = 'subscription-renewal',
  NONE = 'none',
}
